import { data } from '../../svg/SmartToy/data';
import { makeIcon } from '../makeIcon';

export const SmartToy = makeIcon(data, 'smart_toy', 'SmartToy');

export default SmartToy;
